import Guard from '../../services/Middleware'

export default [
  {
    path: '/Funcionarios',
    name:'Funcionarios',
    component: () => import('@/views/funcionarios/MenuFuncionarios.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Curriculos',
    name:'Gestão de Curriculos',
    component: () => import('@/views/funcionarios/curriculos/index.vue'),
    beforeEnter: Guard.auth,
  },
  {
    path: '/Funcionarios/Curriculos/add',
    name:'Adicionar Curriculos',
    component: () => import('@/views/funcionarios/curriculos/add.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Curriculos/add/:id',
    name:'Editar Curriculos',
    component: () => import('@/views/funcionarios/curriculos/add.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Administrativo',
    name:'Gestão de Equipe',
    component: () => import('@/views/funcionarios/administrativo/index.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Administrativo/add',
    name:'Adicionar Funcionario',
    component: () => import('@/views/funcionarios/administrativo/add.vue'),
    beforeEnter: Guard.auth
  },
  {
    path: '/Funcionarios/Administrativo/add/:id',
    name:'Editar Funcionario',
    component: () => import('@/views/funcionarios/administrativo/add.vue'),
    beforeEnter: Guard.auth
  }
]